export default __webpack_public_path__ + "static/media/model2.29dd9423.jpg";